import { render, staticRenderFns } from "./byr.vue?vue&type=template&id=454eb0ca&scoped=true&"
import script from "./byr.vue?vue&type=script&lang=js&"
export * from "./byr.vue?vue&type=script&lang=js&"
import style0 from "./byr.vue?vue&type=style&index=0&id=454eb0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454eb0ca",
  null
  
)

export default component.exports